'use strict';
const angular = require('angular');

/*@ngInject*/
export function RequestedUserService($resource) {
  return $resource('/api/requested-users/:id', {
    id: '@_id'
  },{
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    approve: {
      method: 'PUT',
      url: '/api/requested-users/:id/approve'
    },
    activate: {
      method: 'PUT',
      url: '/api/requested-users/:id/activate'
    }
  });
}


export default angular.module('conduu.ap.services.RequestedUserService', [])
  .factory('RequestedUserService', RequestedUserService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/services/requested-user/requested-user.service.js